import PaymentStatusPoller from './payment_status_poller.mjs'

export default class extends HTMLElement {
  connectedCallback () {
    if (this.poller) return

    this.poller = new PaymentStatusPoller({
      fetchStatus: () => this.fetchStatus(),
      onStatus: data => this.showStatus(data),
      onComplete: data => this.showSuccess(data),
      onFailure: data => this.showError(data),
      onReview: data => this.showReview(data)
    })
    this.poller.start()
  }

  disconnectedCallback () {
    this.poller?.stop()
    this.poller = undefined
  }

  async fetchStatus () {
    const transactionUuid = this.dataset.transactionUuid
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const headers = { Accept: 'application/json' }
    if (csrfToken) headers['X-CSRF-Token'] = csrfToken

    const response = await fetch(`/payment_status/${transactionUuid}`, { headers })
    if (!response.ok) throw new Error(`Payment status request failed: ${response.status}`)

    return response.json()
  }

  showStatus (data) {
    this.querySelector('#status-message').textContent = data.message || 'Processing Payment...'
  }

  showSuccess () {
    this.querySelector('#loading-state').classList.add('hidden')
    this.querySelector('#success-state').classList.remove('hidden')

    const toast = this.querySelector('#success-toast')
    setTimeout(() => toast.classList.remove('translate-x-full', 'opacity-0'), 300)
    setTimeout(() => toast.classList.add('translate-x-full', 'opacity-0'), 5300)
  }

  showReview (data) {
    this.querySelector('#loading-state').classList.add('hidden')
    this.querySelector('#review-state').classList.remove('hidden')
    if (data.message) this.querySelector('#review-text').textContent = data.message
  }

  showError (data) {
    this.querySelector('#loading-state').classList.add('hidden')
    this.querySelector('#error-state').classList.remove('hidden')
    this.querySelector('#error-text').textContent = data.message || 'Payment verification timed out'
  }
}
